import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  CustomTokenThemeProvider,
  getPaletteFromStylesheet,
  getPublicDesignToken,
} from '@devopsafs/react-ui-components';

import App from './app';

import { GoogleMapsProvider } from 'src/contexts/google-maps-context';
import { HeaderProvider } from 'src/contexts/header-context';
import { LocalizationProvider } from 'src/contexts/localization-context';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const theme = {
  ...getPublicDesignToken(getPaletteFromStylesheet()),
  '--input-mini-padding-top': '5px',
  '--input-mini-padding-bottom': '5px',
  '--input-placeholder-text-color': '#707070',
};

root.render(
  <GoogleMapsProvider>
    <HeaderProvider>
      <LocalizationProvider>
        <CustomTokenThemeProvider theme={theme}>
          <App />
        </CustomTokenThemeProvider>
      </LocalizationProvider>
    </HeaderProvider>
  </GoogleMapsProvider>
);
